export default __webpack_public_path__ + "static/Cher@2x-5c886aada9559aee4fab07dfed05eaa9.png";